import State from '../classes/State';

export default class extends State {
    static get id() {
        return 3;
    }
}
